var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.71094C12.651 8.71094 12.7917 8.77604 12.9219 8.90625L18.8438 15.1406C18.8958 15.1927 18.9375 15.25 18.9688 15.3125C18.9948 15.375 19.0078 15.4453 19.0078 15.5234C19.0078 15.6224 18.9844 15.7135 18.9375 15.7969C18.8906 15.8802 18.8281 15.9453 18.75 15.9922C18.6667 16.0391 18.5755 16.0625 18.4766 16.0625C18.3203 16.0625 18.1927 16.0104 18.0938 15.9062L12.1563 9.67187L12.8438 9.67187L6.91406 15.9062C6.80469 16.0104 6.67708 16.0625 6.53125 16.0625C6.42708 16.0625 6.33594 16.0391 6.25781 15.9922C6.17969 15.9453 6.11719 15.8802 6.07031 15.7969C6.01823 15.7135 5.99219 15.6224 5.99219 15.5234C5.99219 15.3828 6.04688 15.2578 6.15625 15.1484L12.0781 8.90625C12.1354 8.84375 12.2005 8.79427 12.2734 8.75781C12.3464 8.72656 12.4219 8.71094 12.5 8.71094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.48d90f90.svg";
export { ForwardRef as ReactComponent };